import { useEffect, useState } from "react";

import { useQuery, onlineManager } from "@tanstack/react-query";

export default function useRenderLambdaImage({
  data,
  phaseNumber,
  imageOption,
}) {
  const [error, setError] = useState(null);

  const renderQuery = useQuery({
    queryKey: ["renderLambdaImage", data.play_id, phaseNumber, imageOption], //eslint-disable-line
    queryFn: async () => {
      setError(null);
      let response = await fetch(
        "https://1tfwqecwuk.execute-api.us-east-1.amazonaws.com/prod/image",
        {
          method: "POST",
          body: JSON.stringify({
            data: data,
            phaseNumber: phaseNumber,
            width: imageOption.imageWidth,
          }),
        }
      );
      let responseBlob = await response.blob();
      var urlCreator = window.URL || window.webkitURL;
      var imageUrl = urlCreator.createObjectURL(responseBlob);

      return { imageUrl };
    },
    gcTime: 0,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (!onlineManager.isOnline()) {
      const error = new Error(
        "You are offline. You can only render images when online"
      );

      setError(error);

      return;
    }
  }, [renderQuery.data, renderQuery.isPaused]);

  return {
    ...renderQuery,
    error: error ?? renderQuery.error,
    isError: !!error || renderQuery.isError,
  };
}
